/**
 * Resultado da execução do bypass via `PR_APP_GESTOR_INS_BYPASS`,
 * retornado dentro do campo `bypass` de
 * {@link SwapGravarSessaoResponse}.
 *
 * - `flgSucesso === true`: bypass aplicado (`codRetorno === '00'`).
 * - `flgSucesso === false`: erro de negócio (`codRetorno === '01'`);
 *   a sessão **foi gravada** (resposta HTTP 200), mas o bypass não foi
 *   aplicado. Mostre `dscRetorno` em **aviso** (amarelo).
 */
export interface AppGestorBypassResponse {
  flgSucesso: boolean;
  /** '00' = sucesso; '01' = erro de negócio. */
  codRetorno: string;
  /** Mensagem da proc. */
  dscRetorno: string;
}
